import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { fetchOtpAppWa, updateOtpStatus, addUpdateOtpApp, sendOtp, fetchWhatsappQR } from '../../store/actions/otpAppAction'
import { fetchApp } from '../../store/actions/appAction'
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Grid, Switch, TextField, Button } from '@material-ui/core';
import Swal from 'sweetalert2'

const useStyles = makeStyles((theme) => ({
}));

const Whatsapp = () => {
    const dispatch = useDispatch()
    const classes = useStyles();
    const {id} = useParams()
    const category = 'waOTP'
    const message = `Kode OTP [Nama Brand] Anda xxx-xxx. Gunakan OTP untuk masuk ke aplikasi. Jaga kerahasiaan kode termasuk ke petugas kami`

    const [isActive, setIsActive] = useState(false);
    const [ input, setInput ] = useState({
      brand: '',
      phone: ''
    })
    const [packages, setPackages] = useState('silver');
    const [isDisabled, setIsDisabled] = useState(true)

    useEffect(() => {
      dispatch(fetchApp(id))
    }, [dispatch, id])
    
    const app = useSelector(state => state.appReducer.app)
    
    useEffect(() => {
      dispatch(fetchOtpAppWa(id, category))
      return () => {
          const cleanupInput = {
              brand: '',
              phone: ''
          }
        setInput(JSON.parse(JSON.stringify(cleanupInput)))
      }  
    }, [dispatch, id, category])
    
    const otpApp = useSelector(state => state.otpAppReducer.otpAppWa)
    const loading_OTP = useSelector(state => state.otpAppReducer.loading_OTP)
    const error_OTP = useSelector(state => state.otpAppReducer.error_OTP)

    useEffect(() => {
      if (loading_OTP) {
          Swal.fire({
            title: 'Processing...',
            html: 'Please wait...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading()
            }
          });
      }
      // if (error_OTP) {
      //   Swal.close()        
      // }
      setTimeout(() => {
        Swal.close()
      }, 15000);
      // return () => {
      //   Swal.close()
      // }        
    }, [loading_OTP])

    useEffect(() => {
      if (otpApp) {
        const newInput = {
          brand: otpApp.brand,
          phone: ''
        }
        setIsActive(otpApp.status === 'active')
        setInput(JSON.parse(JSON.stringify(newInput)))
        setIsDisabled(false)              
      } else {
        const newInput = {
          brand: '',
          phone: ''
        }
        setIsActive(false)
        setInput(JSON.parse(JSON.stringify(newInput)))
        setIsDisabled(true)              
      }
    }, [otpApp])

    const handleSubmit = (e) => {
      e.preventDefault()
      input.appId = id
      input.category = category
      dispatch(addUpdateOtpApp(input))
    }

    const handleFormChange = (e) => {
      let { name, value } = e.target
      setInput({ ...input, [name]: value })  
    }

    const handleSwitchChange = (e) => {
      setIsActive(e.target.checked);
      const payload = {appId:id, category, status: e.target.checked }
      if (otpApp) {
        dispatch(updateOtpStatus(payload))
      }
    }

    const waOtpLogin = () => {
      const payload = {apiKey:app.apiKey, phone:input.phone, provider: category }
      dispatch(sendOtp(payload))
    }

    const handlePackage = (e) => {
      e.preventDefault()
      setPackages(e.target.value)
    }

    return (
        <div>
        <Typography component="h1" variant="h5" align="center" color="textPrimary" spacing={4} gutterBottom>
          Whatsapp OTP
        </Typography>
          <br/>
          <Grid item xs={12} md={12} className={classes.contentOtpLogin}>
          <div>
              <Grid
                  container
                  direction="row"
                  justify="space-between"
                  alignItems="center"
                  className="mb-15">
                  <Grid item>
                      <Typography className="d-flex reguler" style={{flexDirection: "row", justifyContent: "center"}}>
                        Whatsapp OTP Form
                      </Typography>        
                  </Grid>
                  <Grid item>
                      <span className="mb-0 reguler text-grey font-size-14">
                          Status: 
                          <span>Enable</span>
                      </span>
                      <Switch
                          checked={isActive}
                          onChange={handleSwitchChange}
                          color="primary"
                          name="checked"
                          inputProps={{ 'aria-label': 'primary checkbox' }}
                      />        
                  </Grid>
              </Grid>
              {
                isActive &&
                <div>
                  <form onSubmit={handleSubmit}>
                    <Grid container spacing={4}>
                      <Grid item xs={12} md={6}>
                        {/* <p className="font-size-16 reguler text-darkgrey" style={{marginBottom: "-5px"}}>Sender ID</p>
                        <TextField
                          variant="outlined"
                          margin="dense"
                          fullWidth
                          id="senderID"
                          name="senderID"
                          value={"081384577547"}
                          autoFocus
                          onChange={handleFormChange}
                          style={{marginBottom: "1.5rem"}}
                        /> */}
                        <p className="font-size-16 reguler text-darkgrey" style={{marginBottom: "-5px"}}>Nama Brand</p>
                        <TextField
                          className="btn-white text-transform-unset"
                          variant="outlined"
                          margin="dense"
                          fullWidth
                          id="brand"
                          name="brand"
                          value={input.brand}
                          onChange={handleFormChange}
                        />
                        <p className={isDisabled? "font-size-16 reguler text-grey" : "font-size-16 reguler text-darkgrey" } style={{marginTop: '50px', marginBottom: "-5px"}}>Masukkan Nomor (+62)</p>
                        <TextField
                          className={isDisabled? "btn-grey text-grey text-transform-unset" : "btn-white text-transform-unset" }
                          disabled={isDisabled}
                          variant="outlined"
                          margin="dense"
                          fullWidth
                          name="phone"
                          id="phone"
                          value={input.phone}
                          onChange={handleFormChange}
                          style={{marginBottom: "1.5rem"}}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}> 
                        <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          className="btn-black text-transform-unset mt-30 mb-5"
                          style={{padding: "5px 40px"}}
                        >
                          Ubah/Simpan
                        </Button>
                        <p className={isDisabled? "font-size-16 reguler text-grey" : "font-size-16 reguler text-darkgrey" } style={{marginTop:'50px', marginBottom: "5px"}}>Contoh Pesan</p>
                        <TextField
                          className={isDisabled? "btn-grey text-grey text-transform-unset" : "btn-white text-transform-unset" }
                          disabled={isDisabled}                          
                          id="message outlined-multiline-static"
                          variant="outlined"
                          margin="none"
                          size="small"
                          defaultValue=""
                          required
                          fullWidth
                          multiline
                          rows={4}
                          name="message"
                          value={message}
                        />

                      </Grid>
                    </Grid>              
                    <div className="d-flex mt-15" style={{justifyContent: "flex-end"}}>
                      <Button
                        className={isDisabled? "btn-grey text-grey text-transform-unset" : "btn-white text-transform-unset" }
                        disabled={isDisabled}
                        variant="contained"
                        color="secondary"
                        onClick={() => waOtpLogin()}
                        // className="btn-white text-transform-unset"
                        style={{padding: "5px 40px", marginRight: "20px"}}
                      >
                        Send Message
                      </Button>
                      {/* <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        className="btn-black text-transform-unset"
                        style={{padding: "5px 40px"}}
                      >
                        Save
                      </Button> */}
                    </div>
                  </form>
                </div>
              }
            </div>
          </Grid>
        </div>
    )
}

export default Whatsapp
